var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test-page container"},[_c('h1',{staticClass:"title"},[_vm._v("Test Page")]),_c('div',{staticClass:"content"},[_c('div',{staticClass:"test-board blue merida"},[_c('div',{ref:"board",staticClass:"cg-board-wrap"})])])])}
var staticRenderFns = []

export { render, staticRenderFns }